import React from 'react';
import IconStart from '@learningblocks/exp-constants/lib/Icons/start-solid';
import colors from '@learningblocks/exp-constants/lib/Styles/_colors.scss';
import {Button} from '../Button';
import './style.scss';

export class ErrorLimitExceeded extends React.Component {
  restartSimulation = () => {
    window.location.reload();
  };
  render() {
    return (
      <div className='exceedLimit'>
        <div className='exceedLimit-title'>
          <h2>
            You made too many mistakes, but not to worry - you can try again.
          </h2>
        </div>
        <div className='exceedLimit-button'>
          <Button
            aria-label='Start simulation button'
            tabIndex={4}
            onClick={this.restartSimulation}>
            <IconStart style={START_ICON_STYLE} />
            Restart simulation
          </Button>
        </div>
      </div>
    );
  }
}

const START_ICON_STYLE = {color: colors.charcoal1, height: '16px', top: '2px'};
